import React from "react";
import "../styles/About.css";

export default ({...content}) => {
    return (
        <div className="about" dangerouslySetInnerHTML={{__html: content.content.content.text}} />
    );
}
